<template>
    <div v-wechat-title="title" style="height: 100%">
        <crud-facecade
            ref="surgery-trace-list"
            :url="url"
            :columns="columnList"
            columnConfig="true"
            :buttons="[]"
            dialogWidth="65%"
            :addButton="{ enabled: false, permission: 'default' }"
            :tableHeight="this.screenHeight - 260"
            :updateButton="{ enabled: false, permission: 'default' }"
            @handlerTransfer_1="handlerTransfer($event, 1)"
            @handlerTransfer_2="handlerTransfer($event, 2)"
            @printDetail="printDetail"
            @printNotice="printNotice"
            @rowClick="loadTransportNode"
            @loadTranferDetailView="loadTranferDetailView"
            :selection="true"
            @selectionChange="checkedRow"
            style="margin-bottom: 100px"
        >
            <slot slot="filter">
                <el-col :md="8" :xl="4" class="align-left">
                    <item-input type="datearraw2" v-model="rdate"></item-input>
                </el-col>
                <el-col :span="4">
                    <item-input type="select" v-model="dic_room_id" :options="operationRoom" :clearable="true" placeholder="手术间"></item-input>
                </el-col>
                <el-col :span="4">
                    <item-input type="select" v-model="activeTransferStatus" :options="allTransferStatus" :clearable="true" placeholder="转运状态"></item-input>
                </el-col>
                <el-col :span="4">
                    <item-input type="string" v-model="wristband" placeholder="请扫描腕带" :autofocus="true" @keyup.native.enter="scanWrist()"></item-input>
                </el-col>
            </slot>
            <slot slot="filter-after">
                <el-button type="primary" size="mini" @click="scanWrist()">刷新</el-button><span>&nbsp;|</span>
                <!-- <el-switch v-model="isOpen" inactive-text="通知" active-value="1" inactive-value="0" @change="OpenNotice()"></el-switch> -->
                <el-button type="primary" size="mini" @click="btnprint()"><i class="el-icon-printer"></i>&nbsp;打印</el-button>
            </slot>
            <template slot="patient_name" slot-scope="{ row }">
                <span>{{ row.patient_name }}</span
                ><span class="circle fg-red borderd" v-if="row.is_reoperation">再</span>
            </template>
        </crud-facecade>
        <el-footer style="position: absolute; bottom: 0; background: white; width: 100%; z-index: 99; margin-left: -10px; height: 100px !important">
            <CusStep :steps="transportNode">
                <!-- <div slot-scope="{ step }">
                    <font-awesome-icon :icon="['fas', 'file-alt']" v-if="step.remark" style="color: black" @click="EditDocument(step)"></font-awesome-icon>
                    <font-awesome-icon :icon="['fas', 'edit']" style="color: black" @click="EditData(step)"></font-awesome-icon>
                </div> -->
            </CusStep>
        </el-footer>
        <cus-dialog title="患者转运记录单" :visible.sync="document.dialogFormVisible" :okVisible="false" :saveAndPrintVisible="true" width="85%" @saveAndPrint="saveAndPrintDocument()" class="dialog-adverse">
            <DocFrame ref="doc" style="height: 580px" :docno="document.docno" :guid="document.docguid" :surgeryId="document.surgeryId" docname="患者转运记录单" @saved="afterDocumentSaved" @saveAndPrint="afterDocumentSavedAndPrint"></DocFrame>
        </cus-dialog>
        <cus-dialog title="备注" :visible.sync="showRemarkObj.isShow" width="25%" @cancel="showRemarkObj.isShow = false" @confirm="confirmAddTransfer">
            <div class="margin10 margin-none-h align-left">
                <el-input type="textarea" :rows="3" v-model="showRemarkObj.remark" placeholder="请录入注意事项"></el-input>
            </div>
        </cus-dialog>
        <cus-dialog title="选择打印单据" :visible.sync="printSurenryForm.dialogFormVisible" width="20%" @confirm="printtype()">
            <div class="margin10 margin-none-h align-left">
                <item-input type="select" v-model="printSurenryForm.selecttype" :options="printSurenryForm.types"></item-input>
            </div>
        </cus-dialog>
        <TranferDetail :visible.sync="showTranferDetail.isShow" :surgeryId="showTranferDetail.surgeryId" :surgeryInfo="showTranferDetail.surgeryInfo"></TranferDetail>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
import TranferDetail from './TranferDetail.vue'
export default {
    name: `TransferHandoverNew`,
    props: {},
    components: { TranferDetail },
    data() {
        return {
            title: `转运交接`,
            rdate: this.$moment().format(`YYYY/MM/DD`),
            dic_operating_ward_id: undefined,
            document: {
                // 当前打开的文书一些内容
                dialogFormVisible: false,
                docguid: ``,
                surgeryId: ``,
                docno: 323
            },
            url: {
                get: () => {
                    return this.loadAllTabData()
                }
            },
            wristband: ``,
            workerList: [],
            isOpen: sessionStorage.getItem(`isOpen`),
            count: 0,
            thisrow: {},
            permissions: [],
            dic_room_id: undefined,
            transferCirculations: null,
            activeTransferStatus: undefined,
            transferInfoList: [],
            allTransferInfoList: [],
            transportNode: [],
            showRemarkObj: {
                isShow: false,
                id: 0,
                biz_surgery_info_id: 0,
                next_dic_transfer_circulation_id: 0,
                remark: ``,
                is_withdraw: false,
                row: null
            },
            showTranferDetail: {
                isShow: false,
                id: 0,
                biz_surgery_info_id: 0,
                surgeryInfo: null
            },
            checkedRows: [],
            printSurenryForm: {
                dialogFormVisible: false,
                selecttype: ``,
                types: [
                    { label: `转运记录单`, value: 1 },
                    { label: `手术通知单`, value: 2 }
                ]
            },
            users: [],
            documentConfig: [],
            isSaving: false
        }
    },
    created() {
        this.loadPermissions()
        // 获取转运流转表
        this.loadTransferCirculations()
        this.$store.dispatch(`ADD_SECTION`)
        this.$store.dispatch(`sysuser/ADD_WORKERS`)
        this.loadAllUsers()
        this.loadDocumentConfig()
    },
    computed: {
        ...mapGetters([`section`, `active_ward`, `screenHeight`, `sysuser/workers`, `currentUser`, `ward_auth`]),
        operationRoom() {
            return (
                (this.active_ward &&
                    this.active_ward.operation_room &&
                    this.active_ward.operation_room.map(d => {
                        d.code = ``
                        return d
                    })) ||
                []
            )
        },
        columnList() {
            let obj = this
            let list =
                (this.active_ward &&
                    this.active_ward.operation_room &&
                    this.active_ward.operation_room.map(d => {
                        d.code = ``
                        return d
                    })) ||
                []
            return [
                {
                    type: `string`,
                    prop: `id`,
                    label: `编号`,
                    isListable: false,
                    isKey: true
                },
                {
                    type: `string`,
                    prop: `patient_name`,
                    label: `姓名`,
                    width: `80`,
                    queryable: true
                },
                {
                    type: `custom`,
                    prop: `patient_name`,
                    label: `姓名`,
                    width: `80`,
                    isListable: true,
                    fixed: `left`
                },
                {
                    type: `string`,
                    prop: `transfer_status`,
                    label: `转运状态`,
                    width: `120`,
                    isListable: true
                },
                {
                    type: `string`,
                    prop: `flow_surgery_stage`,
                    label: `转运阶段`,
                    width: `120`,
                    isListable: true
                },
                {
                    type: `datetime`,
                    prop: `transfer_start_date`,
                    label: `转运开始时间`,
                    width: `120`,
                    isListable: true
                },
                {
                    type: `string`,
                    prop: `sex`,
                    label: `性别`,
                    width: `60`,
                    isListable: true
                },
                {
                    type: `string`,
                    prop: `age`,
                    label: `年龄`,
                    width: `60`,
                    isListable: true
                },
                {
                    type: `string`,
                    prop: `visit_no`,
                    label: this.T(`transfer_handover.visit_no`),
                    width: `60`,
                    isListable: true
                },
                {
                    type: `string`,
                    prop: `dic_section`,
                    label: `科室`,
                    width: `100`,
                    isListable: true
                },
                {
                    type: `select`,
                    prop: `dic_section_id`,
                    label: `科室`,
                    width: `100`,
                    isListable: false,
                    isExpand: false,
                    isEditable: false,
                    isCreatable: false,
                    searchable: true,
                    options: this[`section`]
                },
                {
                    type: `string`,
                    prop: `bed_no`,
                    label: `床号`,
                    width: `60`,
                    isListable: true
                },
                {
                    type: `string`,
                    prop: `dic_operating_room`,
                    label: `手术间`,
                    width: `100`,
                    sortable: true,
                    isListable: true
                },
                {
                    type: `select`,
                    prop: `dic_operating_room_id`,
                    label: `手术间`,
                    options: list,
                    width: `100`,
                    isListable: false,
                    isExpand: false,
                    isEditable: false,
                    isCreatable: false,
                    searchable: true
                },
                {
                    type: `string`,
                    prop: `scheduled_sequence`,
                    label: `台次`,
                    width: `60`,
                    sortable: true,
                    isListable: true
                },
                {
                    type: `string`,
                    prop: `surgeries`,
                    label: `拟施手术`,
                    isListable: true,
                    width: `150`,
                    searchable: true
                },
                {
                    type: `string`,
                    prop: `diseases`,
                    label: `术前诊断`,
                    isListable: true,
                    width: `150`,
                    searchable: true
                },
                {
                    type: `string`,
                    prop: `surgeon`,
                    label: `主刀医生`,
                    width: `80`,
                    isListable: true
                },
                {
                    type: `datetime`,
                    prop: `plan_time`,
                    label: `计划手术时间`,
                    width: `100`,
                    isListable: true
                },
                {
                    type: `buttongroup`,
                    prop: `oper`,
                    label: `操作`,
                    width: `450`,
                    // fixed:"right",
                    isListable: true,
                    readonly: false,
                    options: (that, { row }) => {
                        let r = []
                        if (obj.isHaveWithDrawRole(row)) {
                            let nodebtn = {
                                class: `is-plain`,
                                label: `撤回`,
                                icon: ``,
                                type: `primary`,
                                emit: `handlerTransfer_1`,
                                permission: `default`
                            }
                            r.push(nodebtn)
                        }
                        if (row.next_transfer_circulation && obj.isHaveHandRole(row.next_transfer_circulation)) {
                            _.forEach(row.next_transfer_circulation.buttonNames, bname => {
                                if (bname) {
                                    let nextbtn = {
                                        class: `is-plain`,
                                        label: bname,
                                        icon: ``,
                                        type: `primary`,
                                        emit: `handlerTransfer_2`,
                                        permission: `default`
                                    }
                                    r.push(nextbtn)
                                }
                            })
                        }
                        return r.concat([
                            {
                                class: `is-plain`,
                                label: `打印`,
                                icon: ``,
                                type: `primary`,
                                emit: `printDetail`,
                                permission: `default`
                            },
                            {
                                class: `is-plain`,
                                label: `通知单`,
                                icon: ``,
                                type: `primary`,
                                emit: `printNotice`,
                                permission: `default`
                            },
                            // 现在是按流程节点来的，到谁了谁了谁可以操作，不存在补录的情况，先注释
                            // , {
                            //     class: `is-plain`,
                            //     label: `补录`,
                            //     icon: ``,
                            //     type: `primary`,
                            //     emit: `loadSupplementView`,
                            //     permission: `default`
                            // }
                            {
                                class: `is-plain`,
                                label: `详情`,
                                icon: ``,
                                type: `primary`,
                                emit: `loadTranferDetailView`,
                                permission: `default`
                            }
                        ])
                    },
                    config: {
                        align: `flex-start`
                    }
                }
            ]
        },
        allTransferStatus() {
            let that = this
            let surgeryStatus = [
                { label: `全部`, value: `全部` },
                { label: `已排程`, value: `已排程` },
                { label: `手术中`, value: `手术中` },
                { label: `手术结束`, value: `手术结束` },
                { label: `苏醒中`, value: `苏醒中` },
                { label: `苏醒结束`, value: `苏醒结束` }
            ]
            let stateNames = _.uniqBy(that.transferCirculations, `data_state_name`).map(i => {
                return { label: i.data_state_name, value: i.data_state_name }
            })
            return surgeryStatus.concat(stateNames)
        }
    },
    methods: {
        loadDocumentConfig() {
            let that = this
            return new Promise((resolve, reject) => {
                let req = this.myaxios.get(`/api/AcisSystem/DocumentConfig/Get`)
                req.then(DocumentConfig => {
                    that.documentConfig = DocumentConfig
                    resolve(DocumentConfig)
                })
            })
        },
        loadDocument(target, index) {
            let { row } = target
            this.thisrow = row
            let nextNode = row.next_transfer_circulation
            this.document.docno = nextNode.doc_code
            let doc = this.documentConfig.find(i => i.document_id == this.document.docno)
            if (!this.document.docno || !doc) {
                this.$message.warning(`未查到相关文书，请确认患者转运的文书配置！`)
                return
            }
            this.document.docguid = `患者转运记录单_${row.biz_surgery_info_id}_${this.document.docno}`
            this.document.surgeryId = row.biz_surgery_info_id
            this.document.dialogFormVisible = true
            this.document.target = target
            this.document.index = index
            this.$nextTick(() => {
                this.$refs.doc.loadDocument()
            })
        },
        afterDocumentSaved(data) {
            if (this.document.target) {
                this.putNextStep(this.document.target, this.document.index, false)
            }
            this.isSaving = false
        },
        afterDocumentSavedAndPrint() {
        },
        checkedRow({ row }) {
            this.checkedRows = row
        },
        saveAndPrintDocument() {
            this.isSaving = true
            this.$refs[`doc`].saveAndprint()
            this.toPrint()
        },
        toPrint() {
            let that = this
            let awaitIndex = 0
            let awaitUntilEqual = () => {
                awaitIndex++
                if (that.isSaving == true && awaitIndex < 500) {
                    requestAnimationFrame(awaitUntilEqual)
                    return
                }
                let savefalg = window.localStorage.getItem(`savefalg`)
                if (savefalg == `False`) {
                    this.$message.error(`请先保存文书`)
                    return
                }
                if (awaitIndex >= 500) {
                    this.$message.error(`打印超时，请刷新后重试~`)
                } else {
                    console.log(`11111111111111111111111`, that.$refs)
                    that.$refs[`doc`].print()
                }
            }
            awaitUntilEqual()
        },
        btnprint() {
            this.printSurenryForm.dialogFormVisible = true
        },
        printtype() {
            this.printSurenryForm.dialogFormVisible = false
            let docId = this.printSurenryForm.selecttype == 1 ? this.$root.DOCUMENT.HZZY006 : this.$root.DOCUMENT.PC008
            // 批量打印手术通知单
            let printlist = this.checkedRows
            if (printlist.length) {
                this.$store.dispatch(`PRINT_PDF`, {
                    host: this.$root.DOCSERVICE_BASE,
                    params: {
                        docid: docId,
                        id1: printlist.map(d => d.biz_surgery_info_id).toString(),
                        objId: printlist.map(d => d.biz_surgery_info_id).toString()
                    }
                })
            } else {
                this.$message.warning(`请选择需要打印的手术`)
            }
        },
        putNextStep(target, index, isShowRemarkDialog = true) {
            let { row } = target
            let transferInfo = row
            this.thisrow = row
            let nextTransferCirculation = transferInfo.next_transfer_circulation
            this.showRemarkObj.btnName = target.op && target.op.label
            this.showRemarkObj.remark = ``
            this.showRemarkObj.id = transferInfo.id
            this.showRemarkObj.biz_surgery_info_id = transferInfo.biz_surgery_info_id
            this.showRemarkObj.next_dic_transfer_circulation_id = (nextTransferCirculation && nextTransferCirculation.id) || 0
            this.showRemarkObj.is_withdraw = index == 1
            if (isShowRemarkDialog) {
                this.showRemarkObj.isShow = true
            } else {
                this.confirmAddTransfer()
            }
        },
        handlerTransfer(target, index) {
            console.log(target)
            let { row } = target
            let nextNode = row.next_transfer_circulation
            if (index == 1 || (nextNode && !nextNode.doc_code)) {
                // 撤回操作 或者 节点没有配置文书的直接 去到下一个节点
                this.putNextStep(target, index)
            } else {
                this.loadDocument(target, index)
            }
        },
        confirmAddTransfer() {
            let that = this
            return new Promise((resolve, reject) => {
                let data = {
                    id: that.showRemarkObj.id, // 当前转运记录对应id
                    biz_surgery_info_id: that.showRemarkObj.biz_surgery_info_id,
                    is_withdraw: that.showRemarkObj.is_withdraw, // 是否是撤回操作
                    button_name: that.showRemarkObj.btnName,
                    remark: that.showRemarkObj.remark || ``,
                    next_dic_transfer_circulation_id: that.showRemarkObj.next_dic_transfer_circulation_id // 下一转运节点ID，即点击的按钮对应的id
                }
                let req = that.myaxios.mobile_post(`/api/TransferEvent/TransferOccurEvent/PostTransfer`, data)
                req.then(async data => {
                    that.$message.success(`保存成功！`)
                    if (!that.showRemarkObj.is_withdraw) {
                        let nextNode = that.thisrow.next_transfer_circulation
                        if (nextNode.message_template) {
                            // 定义了消息模板，则发消息
                            that.sendMessage(data)
                        }
                    } else {
                        that.withDrawMessage(that.showRemarkObj.id)
                    }
                    that.showRemarkObj.isShow = false
                    that.loadTransportNode({ row: that.thisrow })
                    this.$refs[`surgery-trace-list`].ReloadListData()
                    resolve()
                }).catch(e => {
                    that.showRemarkObj.isShow = false
                    this.$refs[`surgery-trace-list`].ReloadListData()
                })
            })
        },
        isHaveWithDrawRole(transferInfo) {
            let surgeryInfo = transferInfo.surgery_info
            let currentTransferCirculation = transferInfo.transfer_circulation
            if (
                this.currentUser &&
                transferInfo.dic_worker_id == this.currentUser.dic_worker_id &&
                surgeryInfo.dic_transfer_circulation_id > 0 &&
                currentTransferCirculation &&
                currentTransferCirculation.is_alow_withdraw
            ) {
                return true
            } else {
                return false
            }
        },
        isHaveHandRole(transferCirculation) {
            if (transferCirculation && transferCirculation.id > 0 && this.currentUser && this.currentUser.workerInfo && this.currentUser.workerInfo.Enum_WorkerRole) {
                return transferCirculation.worker_role_arr && transferCirculation.worker_role_arr.indexOf(this.currentUser.workerInfo.Enum_WorkerRole) > -1
            } else {
                return false
            }
        },
        scanWrist() {
            this.$refs[`surgery-trace-list`].ReloadListData()
        },
        sendMessage(data) {
            let nextNode = data.next_transfer_circulation
            // 消息发送
            let messageheader = this.createMessageHeader(data)
            messageheader.ac_sys_user_roles = nextNode.worker_role_arr.join(`,`)
            this.saveMessage(messageheader)
        },
        createMessageHeader(data) {
            let surgeryInfo = data.surgery_info
            let currentNode = this.thisrow.next_transfer_circulation
            let title = `${data.modifier}给你发了消息`
            let content = `${currentNode.message_template}${data.remark != `` ? `,特别关注:` + data.remark : ``} `
            content = content.replace(`{患者姓名}`, surgeryInfo.patient_name)
            content = content.replace(`{手术医生}`, surgeryInfo.surgeon)
            content = content.replace(`{登陆用户}`, this.currentUser.dic_worker_name)

            let message = {
                content: content,
                isExtraBtnClick: false,
                send_type: 2,
                title: title,
                is_alow_receive: true,
                biz_id: data.id,
                biz_type: `6`,
                enum_message_status: 1
            }
            return message
        },
        getReceiverIds(receiverRoles) {
            let that = this
            let roleWorkerIds = _.filter(this[`sysuser/workers`], worker => {
                return receiverRoles.indexOf(worker.enum_worker_role) > -1
            }).map(i => i.id)
            let roleUserIds = that.getAcUserId(roleWorkerIds)
            return roleUserIds || []
        },
        getAcUserId(roleWorkerIds) {
            let userids = _.filter(this.users, user => {
                return user.is_deleted == false && roleWorkerIds.indexOf(user.dic_worker_id) > -1
            }).map(i => i.id)
            return userids || []
        },
        saveMessage(row) {
            return new Promise((resolve, reject) => {
                let req = this.myaxios.post(`/api/Operation/MessageHeader/Save`, row)
                req.then(data => {
                    resolve(data)
                }).catch(e => reject(e))
            })
        },
        withDrawMessage(tranferId) {
            this.myaxios.delete(`/api/Operation/MessageHeader/DeleteByBizId?bizId=${tranferId}`)
        },
        loadTransferCirculations() {
            let that = this
            return new Promise((resolve, reject) => {
                let req = this.myaxios.get(`/api/TransferEvent/TransferCirculation/Get`)
                req.then(async data => {
                    that.transferCirculations = data
                    resolve()
                }).catch(e => reject(e))
            })
        },
        loadAllUsers() {
            let that = this
            return new Promise((resolve, reject) => {
                let req = this.myaxios.get(`/api/AcisSystem/SysUser/Get`)
                req.then(async data => {
                    that.users = data
                    resolve()
                }).catch(e => reject(e))
            })
        },
        printDetail({ row }) {
            this.$store.dispatch(`PRINT_PDF`, {
                host: this.$root.DOCSERVICE_BASE,
                params: {
                    docid: this.$root.DOCUMENT.HZZY006,
                    id1: row.biz_surgery_info_id,
                    objId: row.biz_surgery_info_id
                }
            })
        },
        printDetail2(row) {
            // 消息提醒打印通知单
            this.$store.dispatch(`PRINT_PDF`, {
                host: this.$root.DOCSERVICE_BASE,
                params: {
                    docid: this.$root.DOCUMENT.PC008,
                    id1: row.biz_surgery_info_id,
                    objId: row.biz_surgery_info_id
                }
            })
        },
        printNotice({ row }) {
            // 打印通知单
            this.$store.dispatch(`PRINT_PDF`, {
                host: this.$root.DOCSERVICE_BASE,
                params: {
                    docid: this.$root.DOCUMENT.PC008,
                    id1: row.biz_surgery_info_id,
                    objId: row.biz_surgery_info_id
                }
            })
        },
        loadTransportNode({ row }) {
            this.thisrow = row
            let req = this.myaxios.get(`/api/TransferEvent/TransferOccurEvent/GetSurgeryTransfer?surgeryId=${row.biz_surgery_info_id}`)
            req.then(data => {
                // 所有事件都展示出来
                // let statusdata = _.filter(data, { status: 1 })
                let statusdata = data
                this.transportNode =
                    statusdata &&
                    _.map(statusdata, d => {
                        d.title = d.event_name
                        d.status = d.id > 0 ? `primary` : `info`
                        return d
                    })
                console.log(this.transportNode)
            }).catch(e => {
                console.log(e)
            })
        },
        loadTranferDetailView({ row }) {
            this.showTranferDetail.isShow = true
            this.showTranferDetail.surgeryId = row.biz_surgery_info_id
            this.showTranferDetail.surgeryInfo = row.surgery_info
        },
        loadPermissions() {
            let req = this.myaxios.get(`/api/AcisSystem/Authorization/GetPermissions`) // 获取当前用户的权限
            req.then(data => {
                this.permissions = data
                console.log(this.permissions)
            }).catch(e => {})
        },
        getSearchCondition() {
            let begin = this.$moment(this.rdate).format(`YYYY-MM-DD`)
            let end = this.$moment(this.rdate)
                .add(1, `days`)
                .format(`YYYY-MM-DD`)
            let condition = {
                begin: begin,
                end: end,
                dic_hospital_ward_Id: this.active_ward.groupId,
                operatingRoomIds: (this.dic_room_id && [this.dic_room_id]) || [],
                recoveryWardIds: []
            }
            return condition
        },
        loadAllTabData() {
            let that = this
            let searchCondition = that.getSearchCondition()
            return new Promise((resolve, reject) => {
                let data = {
                    begin: searchCondition.begin,
                    end: searchCondition.end,
                    dic_hospital_ward_Id: searchCondition.dic_hospital_ward_Id || 0,
                    operatingRoomIds: searchCondition.operatingRoomIds || [],
                    recoveryWardIds: searchCondition.recoveryWardIds || [],
                    group_name: `全部`,
                    visit_no: that.wristband
                }
                let req = this.myaxios.post(`/api/TransferEvent/TransferOccurEvent/GetTransferList`, data)
                req.then(data => {
                    that.allTransferInfoList = data.map(t => {
                        let tran = {
                            id: t.transfer_id == 0 ? t.biz_surgery_info_id : t.transfer_id,
                            biz_surgery_info_id: t.biz_surgery_info_id,
                            dic_worker_id: t.dic_worker_id,
                            patient_name: t.patient_name,
                            flow_surgery_stage: t.next_transfer_circulation && t.next_transfer_circulation.flow_surgery_stage,
                            transfer_status: t.transfer_status,
                            transfer_start_date: t.transfer_start_date,
                            sex: t.surgery_info && t.surgery_info.sex,
                            age: t.age,
                            dic_inpatient_section: t.surgery_info.dic_inpatient_section,
                            dic_section: t.surgery_info.dic_section,
                            dic_section_id: t.surgery_info.dic_section_id,
                            dic_operating_ward_id: t.surgery_info.dic_operating_ward_id,
                            dic_operating_room: t.dic_operating_room,
                            dic_operating_room_id: t.surgery_info.dic_operating_room_id,
                            visit_no: t.visit_no,
                            bed_no: t.bed_no,
                            diseases: t.diseases,
                            surgeries: t.surgeries,
                            surgeon: t.surgeon,
                            scheduled_sequence: t.scheduled_sequence,
                            plan_time: t.surgery_info.plan_time,
                            next_transfer_circulation: t.next_transfer_circulation,
                            surgery_info: t.surgery_info,
                            transfer_circulation: t.transfer_circulation
                        }
                        return tran
                    })
                    that.allTransferInfoList = _.orderBy(that.allTransferInfoList, [`plan_time`, `scheduled_sequence`], [`asc`, `asc`])
                    that.transferInfoList = _.cloneDeep(that.allTransferInfoList)
                    // 前端数据过滤,转运状态文字,前端过滤
                    that.transferInfoList = _.filter(that.transferInfoList, transfer => {
                        return transfer.dic_operating_ward_id == that.active_ward.origion || transfer.dic_recovery_bed_id == that.active_ward.origion
                    })
                    if (that.activeTransferStatus && that.activeTransferStatus != `` && that.activeTransferStatus != `全部`) {
                        that.transferInfoList = _.filter(that.transferInfoList, { transfer_status: that.activeTransferStatus })
                    }
                    if (that.transferInfoList && that.transferInfoList.length > 0 && this.transportNode.length == 0) {
                        this.loadTransportNode({ row: that.transferInfoList[0] })
                    } else if (that.transferInfoList.length == 0) {
                        this.transportNode = []
                    }
                    resolve(that.transferInfoList)
                }).catch(e => {})
            })
        }
    },
    watch: {
        rdate: function(newUrl, oldUrl) {
            this.$refs[`surgery-trace-list`].ReloadListData()
        },
        'active_ward.value': function(newUrl, oldUrl) {
            this.$refs[`surgery-trace-list`].ReloadListData()
        },
        count: function() {
            this.$refs[`surgery-trace-list`].ReloadListData()
        },
        dic_room_id: function() {
            this.$refs[`surgery-trace-list`].ReloadListData()
        },
        activeTransferStatus: function() {
            this.$refs[`surgery-trace-list`].ReloadListData()
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/Transfer/HandoverNew.vue